import { Validators } from '@angular/forms';

export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}

export const USERVALIDATORS = {
  CREATE : new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(false, [])],
    ['nom',  new FormInfo(false, [Validators.required])],
    ['prenom',  new FormInfo(false, [Validators.required])],
    ['email',  new FormInfo(false, [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')])],
    ['tel',  new FormInfo(false, [Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'), Validators.maxLength(10), Validators.minLength(10)])],
    ['actif',  new FormInfo(false, [])],
    ['dCreation', new FormInfo(false, [])],
    ['idCreateur', new FormInfo(false, [])],
    ['dModification', new FormInfo(false, [])],
    ['idModifieur', new FormInfo(false, [])],
    ['dDesactivation', new FormInfo(false, [])],
    ['idDesativateur', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [Validators.required])],
    // ['password', new FormInfo(false, [])],
    ['societe', new FormInfo(false, [])],
  ]),
  EDIT: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(false, [])],
    ['nom',  new FormInfo(false, [Validators.required])],
    ['prenom',  new FormInfo(false, [Validators.required])],
    ['email',  new FormInfo(false, [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')])],
    ['tel',  new FormInfo(false, [Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'), Validators.maxLength(10), Validators.minLength(10)])],
    ['actif',  new FormInfo(false, [])],
    ['dCreation', new FormInfo(false, [])],
    ['idCreateur', new FormInfo(false, [])],
    ['dModification', new FormInfo(false, [])],
    ['idModifieur', new FormInfo(false, [])],
    ['dDesactivation', new FormInfo(false, [])],
    ['idDesativateur', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [Validators.required])],
    // ['password', new FormInfo(false, [])],
    ['societe', new FormInfo(false, [])],
  ])
};

export const DROITVALIDATORS = {
  CREATE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
    ['type', new FormInfo(false, [Validators.required])],
    ['niveau', new FormInfo(false, [Validators.required])],
    ['codeCa1', new FormInfo(false, [])],
    ['idUser', new FormInfo(false, [])],
    ['idCreateur', new FormInfo(false, [])],
    ['dModification', new FormInfo(false, [])],
    ['idModifieur', new FormInfo(false, [])],
    ['dDesactivation', new FormInfo(false, [])],
    ['idDesativateur', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [Validators.required])],
    ['societe', new FormInfo(false, [])],
    ['destinations', new FormInfo(false, [])],
  ])
};

export const DROITDTOVALIDATORS = {
  CREATE: new Map<string, FormInfo>([
    ['idUser', new FormInfo(false, [Validators.required])],
    ['idSociete', new FormInfo(false, [Validators.required])],
    ['codeSociete', new FormInfo(false, [Validators.required])],
    ['codeCa1', new FormInfo(false, [])],
    ['visualiseBC', new FormInfo(false, [])],
    ['commerce', new FormInfo(false, [])],
    ['fraisGeneraux', new FormInfo(false, [])],
    ['exploitation', new FormInfo(false, [])],
    ['livBc', new FormInfo(false, [])],
    ['createBc', new FormInfo(false, [])],
    ['valid1', new FormInfo(false, [])],
    ['valid2', new FormInfo(false, [])],
    ['valid3', new FormInfo(false, [])],
    ['valid4', new FormInfo(false, [])],
    ['valid5', new FormInfo(false, [])],
    ['importBCAValid', new FormInfo(false, [])],
    //['importBCNonProv', new FormInfo(false, [])],
    ['importBCProv', new FormInfo(false, [])],
    ['interfaceSage', new FormInfo(false, [])],
    ['usersManager', new FormInfo(false, [])],
    ['repositoriesManager', new FormInfo(false, [])],
    ['idLigneTableau', new FormInfo(false, [])],
    ['refuse', new FormInfo(false, [])],
    ['messageRefus', new FormInfo(false, [])],
  ]),
  EDIT: new Map<string, FormInfo>([
    ['idUser', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [])],
    ['codeSociete', new FormInfo(false, [])],
    ['codeCa1', new FormInfo(false, [])],
    ['visualiseBC', new FormInfo(false, [])],
    ['commerce', new FormInfo(false, [])],
    ['fraisGeneraux', new FormInfo(false, [])],
    ['exploitation', new FormInfo(false, [])],
    ['livBc', new FormInfo(false, [])],
    ['createBc', new FormInfo(false, [])],
    ['valid1', new FormInfo(false, [])],
    ['valid2', new FormInfo(false, [])],
    ['valid3', new FormInfo(false, [])],
    ['valid4', new FormInfo(false, [])],
    ['valid5', new FormInfo(false, [])],
    ['importBCAValid', new FormInfo(false, [])],
    //['importBCNonProv', new FormInfo(false, [])],
    ['importBCProv', new FormInfo(false, [])],
    ['interfaceSage', new FormInfo(false, [])],
    ['usersManager', new FormInfo(false, [])],
    ['repositoriesManager', new FormInfo(false, [])],
    ['idLigneTableau', new FormInfo(false, [])],
    ['refuse', new FormInfo(false, [])],
    ['messageRefus', new FormInfo(false, [])],
  ])
};
